import React, { useEffect, useState } from 'react';
import { useAuth } from '../../../../hooks/auth';
import api from '../../../../services/api';

export function useRoundsEmAndamento<T>() {
  const [rounds, setRounds] = useState<T | null>(null);
  const { user } = useAuth();

  async function handleSetRounds(page = 1, search?: string, title?: string) {
    setRounds(null);
    if (title) {
      const { data } = await api.get('/rounds', {
        params: {
          page,
          responsable_id: user?.id,
          name: title,
        },
      });
      setRounds(() => data);
    } else if (!search) {
      const { data } = await api.get('/rounds', {
        params: {
          page,
          responsable_id: user?.id,
          em_homologacao: "T",
          homologado: "F",
        },
      });
      setRounds(data);
    } else {
      const { data } = await api.get('/rounds', {
        params: {
          page,
          responsable_id: user?.id,
          data: search,
        },
      });
      setRounds(data);
    }
  }
  useEffect(() => {
    handleSetRounds();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { rounds, handleSetRounds };
}
